import { Logo } from '@clickio/tokens/Logo';
import { useApiHealth } from '@clickio/tokens/useApiHealth';

import s from './App.module.css';

const DOT = { checking: '#FFC53D', ok: '#9CD46B', down: '#FF5C6C' } as const;
const LABEL = { checking: 'Проверяем API…', ok: 'API работает', down: 'API не отвечает' } as const;

export function App() {
  const health = useApiHealth();
  return (
    <div className={s.page}>
      <section className={s.card}>
        <div className={s.brand}>
          <Logo />
          <span className={s.name}>clickio</span>
          <span className={s.badge}>admin</span>
        </div>
        <h1 className={s.title}>Админка в сборке</h1>
        <p className={s.sub}>Вход через Telegram и разделы появятся на этапе 7.</p>
        <div className={s.status} role="status">
          <span className={s.dot} style={{ background: DOT[health] }} />
          {LABEL[health]}
        </div>
      </section>
    </div>
  );
}
